import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";
// import reselect from "reselect";

import OverviewLayoutContainer from "../OverviewLayout/container";
import PreviewList from "../PreviewList";
import PrimaryButton from "../PrimaryButton";

// returns true if any values in a are the same as any values in b
const arraysIntersect = (a, b) => {
  return a.some(value => b.includes(value));
};

export const filterArticles = (filterTags, articles, onClick) => {
  let filteredArticles;
  if (filterTags.length === 0) {
    filteredArticles = articles;
  } else {
    // filter to articles that have any of the filterTags
    filteredArticles = articles.filter(article =>
      arraysIntersect(article.tags, filterTags)
    );
  }

  // Add custom click handlers to Next links
  return filteredArticles.map(article => ({
    ...article,
    onClick
  }));
};

const CheckboxControl = ({ onChange, checked, label, id }) => {
  return (
    <div className={styles.checkbox}>
      <label className={styles.checkboxLabel}>
        <input
          name={id}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className={styles.checkboxControl}
        />
        {label}
      </label>
    </div>
  );
};

CheckboxControl.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.number
};

class FilterOverview extends Component {
  constructor(props) {
    super(props);

    const { filterTags, tags, articles, onPreviewClick } = props;
    this.state = {
      checkboxes: this.checkboxesFromTags(filterTags, tags),
      filteredArticles: filterArticles(filterTags, articles, onPreviewClick)
    };

    this.filterClick = this.filterClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filterTags !== this.props.filterTags) {
      const { filterTags, tags, articles, onPreviewClick } = nextProps;
      const checkboxes = this.checkboxesFromTags(filterTags, tags);
      const filteredArticles = filterArticles(
        filterTags,
        articles,
        onPreviewClick
      );
      this.setState({
        checkboxes,
        filteredArticles
      });
      // push article ids into state for usage elsewhere
      this.props.onSetArticles(
        filteredArticles.map(article => article.articleId)
      );
    }
  }

  checkboxesFromTags(filterTags, tags) {
    const checkboxes = {};

    // Set state for checkboxes, default to unchecked
    tags.forEach(tag => {
      checkboxes[tag.tagId] = false;
    });

    // Check any previously checked checkboxes
    filterTags.forEach(filterTag => {
      checkboxes[filterTag] = true;
    });

    return checkboxes;
  }

  filterClick(e) {
    const { filterTags, onUpdateFilter } = this.props;
    const { checked } = e.target;
    const id = parseInt(e.target.name, 10);
    let newTags;
    if (checked) {
      newTags = [...filterTags, id];
    } else {
      newTags = filterTags.filter(tagId => tagId !== id);
    }
    return onUpdateFilter(newTags);
  }

  render() {
    const { articles, tags, onDownloadClick, onResetClick } = this.props;
    const { checkboxes, filteredArticles } = this.state;
    const resultCount =
      filteredArticles.length === articles.length
        ? "all"
        : filteredArticles.length;
    return (
      <OverviewLayoutContainer
        overview={
          <div className={styles.root}>
            <h1 data-chapter={"00"} className={styles.title}>
              Filter Articles
            </h1>
            <div className={styles.chapterContent}>
              <div className={styles.chapterContentInner}>
                <div className={styles.overview}>
                  <h2 className={styles.overviewText}>
                    Showing{" "}
                    <span className={styles.resultCount}>{resultCount}</span>{" "}
                    article{resultCount === 1 ? "" : "s"}
                  </h2>
                  <button className={styles.resetButton} onClick={onResetClick}>
                    Reset
                  </button>
                </div>
                <div className={styles.section}>
                  {tags &&
                    tags.map(tag => (
                      <CheckboxControl
                        key={tag.tagId}
                        id={tag.tagId}
                        label={tag.name}
                        checked={checkboxes[tag.tagId]}
                        onChange={this.filterClick}
                      />
                    ))}
                </div>
                <div className={styles.download}>
                  <PrimaryButton
                    onClick={onDownloadClick}
                    disabled={
                      filteredArticles.length === 0 ||
                      filteredArticles.length === articles.length
                    }
                  >
                    Download PDF
                  </PrimaryButton>
                </div>
              </div>
            </div>
          </div>
        }
        previews={
          <PreviewList enableAnims={true} previews={filteredArticles} />
        }
      />
    );
  }
}

FilterOverview.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      articleId: PropTypes.number
    })
  ),
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      tagId: PropTypes.number,
      name: PropTypes.string
    })
  ),
  filterTags: PropTypes.arrayOf(PropTypes.number),
  onUpdateFilter: PropTypes.func,
  onResetClick: PropTypes.func,
  onSetArticles: PropTypes.func,
  onDownloadClick: PropTypes.func,
  onPreviewClick: PropTypes.func
};

export default FilterOverview;



// WEBPACK FOOTER //
// ./src/components/FilterOverview/index.js